module.exports = __webpack_public_path__ + "assets/30m.3796aace.svg";